/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Rechtsform {
    Einzelunternehmen = 'Einzelunternehmen',
    GesellschaftMitBeschraenkterHaftung = 'GesellschaftMitBeschraenkterHaftung',
    GesellschaftMitBeschraenkterHaftungUndCoKg = 'GesellschaftMitBeschraenkterHaftungUndCoKg',
    Aktiengesellschaft = 'Aktiengesellschaft',
    EingetrageneGenossenschaft = 'EingetrageneGenossenschaft',
    EingetrageneGenossenschaftEgen = 'EingetrageneGenossenschaftEgen',
    ErzeugerUndTaetigkeitsgemeinschaft = 'ErzeugerUndTaetigkeitsgemeinschaft',
    FlexibleKapitalgesellschaft = 'FlexibleKapitalgesellschaft',
    GesellschaftBuergerlichenRechts = 'GesellschaftBuergerlichenRechts',
    Genossenschaft = 'Genossenschaft',
    Kommanditgesellschaft = 'Kommanditgesellschaft',
    KommanditgesellschaftAufAktien = 'KommanditgesellschaftAufAktien',
    KommanditErwerbsgesellschaft = 'KommanditErwerbsgesellschaft',
    KoerperschaftOeffentlichenRechts = 'KoerperschaftOeffentlichenRechts',
    Limited = 'Limited',
    EuropaeischeGesellschaft = 'EuropaeischeGesellschaft',
    OffeneGesellschaft = 'OffeneGesellschaft',
    OffeneHandelsgesellschaft = 'OffeneHandelsgesellschaft',
    Stiftung = 'Stiftung',
    StilleGesellschaft = 'StilleGesellschaft',
    Verein = 'Verein',
    Wohnungseigentuemergemeinschaft = 'Wohnungseigentuemergemeinschaft'
  }

    export const RechtsformTranslocoMap: Record<Rechtsform, string> = {
    [Rechtsform.Einzelunternehmen]: 'rechtsform.einzelunternehmen',
    [Rechtsform.GesellschaftMitBeschraenkterHaftung]: 'rechtsform.gesellschaftMitBeschraenkterHaftung',
    [Rechtsform.GesellschaftMitBeschraenkterHaftungUndCoKg]: 'rechtsform.gesellschaftMitBeschraenkterHaftungUndCoKg',
    [Rechtsform.Aktiengesellschaft]: 'rechtsform.aktiengesellschaft',
    [Rechtsform.EingetrageneGenossenschaft]: 'rechtsform.eingetrageneGenossenschaft',
    [Rechtsform.EingetrageneGenossenschaftEgen]: 'rechtsform.eingetrageneGenossenschaftEgen',
    [Rechtsform.ErzeugerUndTaetigkeitsgemeinschaft]: 'rechtsform.erzeugerUndTaetigkeitsgemeinschaft',
    [Rechtsform.FlexibleKapitalgesellschaft]: 'rechtsform.flexibleKapitalgesellschaft',
    [Rechtsform.GesellschaftBuergerlichenRechts]: 'rechtsform.gesellschaftBuergerlichenRechts',
    [Rechtsform.Genossenschaft]: 'rechtsform.genossenschaft',
    [Rechtsform.Kommanditgesellschaft]: 'rechtsform.kommanditgesellschaft',
    [Rechtsform.KommanditgesellschaftAufAktien]: 'rechtsform.kommanditgesellschaftAufAktien',
    [Rechtsform.KommanditErwerbsgesellschaft]: 'rechtsform.kommanditErwerbsgesellschaft',
    [Rechtsform.KoerperschaftOeffentlichenRechts]: 'rechtsform.koerperschaftOeffentlichenRechts',
    [Rechtsform.Limited]: 'rechtsform.limited',
    [Rechtsform.EuropaeischeGesellschaft]: 'rechtsform.europaeischeGesellschaft',
    [Rechtsform.OffeneGesellschaft]: 'rechtsform.offeneGesellschaft',
    [Rechtsform.OffeneHandelsgesellschaft]: 'rechtsform.offeneHandelsgesellschaft',
    [Rechtsform.Stiftung]: 'rechtsform.stiftung',
    [Rechtsform.StilleGesellschaft]: 'rechtsform.stilleGesellschaft',
    [Rechtsform.Verein]: 'rechtsform.verein',
    [Rechtsform.Wohnungseigentuemergemeinschaft]: 'rechtsform.wohnungseigentuemergemeinschaft',
    };

    export const RechtsformOptions = [
  { value: Rechtsform.Einzelunternehmen, labelKey: 'rechtsform.einzelunternehmen' },
  { value: Rechtsform.GesellschaftMitBeschraenkterHaftung, labelKey: 'rechtsform.gesellschaftMitBeschraenkterHaftung' },
  { value: Rechtsform.GesellschaftMitBeschraenkterHaftungUndCoKg, labelKey: 'rechtsform.gesellschaftMitBeschraenkterHaftungUndCoKg' },
  { value: Rechtsform.Aktiengesellschaft, labelKey: 'rechtsform.aktiengesellschaft' },
  { value: Rechtsform.EingetrageneGenossenschaft, labelKey: 'rechtsform.eingetrageneGenossenschaft' },
  { value: Rechtsform.EingetrageneGenossenschaftEgen, labelKey: 'rechtsform.eingetrageneGenossenschaftEgen' },
  { value: Rechtsform.ErzeugerUndTaetigkeitsgemeinschaft, labelKey: 'rechtsform.erzeugerUndTaetigkeitsgemeinschaft' },
  { value: Rechtsform.FlexibleKapitalgesellschaft, labelKey: 'rechtsform.flexibleKapitalgesellschaft' },
  { value: Rechtsform.GesellschaftBuergerlichenRechts, labelKey: 'rechtsform.gesellschaftBuergerlichenRechts' },
  { value: Rechtsform.Genossenschaft, labelKey: 'rechtsform.genossenschaft' },
  { value: Rechtsform.Kommanditgesellschaft, labelKey: 'rechtsform.kommanditgesellschaft' },
  { value: Rechtsform.KommanditgesellschaftAufAktien, labelKey: 'rechtsform.kommanditgesellschaftAufAktien' },
  { value: Rechtsform.KommanditErwerbsgesellschaft, labelKey: 'rechtsform.kommanditErwerbsgesellschaft' },
  { value: Rechtsform.KoerperschaftOeffentlichenRechts, labelKey: 'rechtsform.koerperschaftOeffentlichenRechts' },
  { value: Rechtsform.Limited, labelKey: 'rechtsform.limited' },
  { value: Rechtsform.EuropaeischeGesellschaft, labelKey: 'rechtsform.europaeischeGesellschaft' },
  { value: Rechtsform.OffeneGesellschaft, labelKey: 'rechtsform.offeneGesellschaft' },
  { value: Rechtsform.OffeneHandelsgesellschaft, labelKey: 'rechtsform.offeneHandelsgesellschaft' },
  { value: Rechtsform.Stiftung, labelKey: 'rechtsform.stiftung' },
  { value: Rechtsform.StilleGesellschaft, labelKey: 'rechtsform.stilleGesellschaft' },
  { value: Rechtsform.Verein, labelKey: 'rechtsform.verein' },
  { value: Rechtsform.Wohnungseigentuemergemeinschaft, labelKey: 'rechtsform.wohnungseigentuemergemeinschaft' },
    ];

